import React, { useEffect, useState } from 'react';
import {
  Box,
  ListItemButton,
  Button,
  ListItemIcon,
  ListItemText,
  Collapse,
  Grid,
  Menu,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Divider,
  Typography,
  Radio,
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CommonButton from 'components/commonButton/CommonButton';
import star from 'assets/images/smStar.svg';
import filterIcon from 'assets/images/filter.svg';
import activeFilter from 'assets/images/whiteFilter.svg';

function CommonFilter(props) {
  const { filterdata, onFilterChange, onRestFilter } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedValues, setSelectedValues] = useState(
    props?.defaultStatus || props?.defaultLocation || []
  );
  const [dropdownOpen, setDropdownOpen] = useState(filterdata?.map(() => true));

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    const defaultValues = [
      ...(props?.defaultStatus || []),
      ...(props?.defaultLocation || []),
    ];
    setSelectedValues(defaultValues);
  }, [props.defaultStatus, props.defaultLocation]);

  const handleCheckboxChange = (event, primaryText) => {
    const value = event.target.value;
    const isChecked = event.target.checked;
    setSelectedValues((prevValues) => {
      if (isChecked) {
        // Add the value if it's not already in the array
        return [...prevValues, value];
      } else {
        // Remove the value if it exists in the array
        return prevValues.filter((v) => v !== value);
      }
    });
  };

  function getIntersection(a, b) {
    const set1 = new Set(a);
    const set2 = new Set(b);
  
    const intersection = [...set1].filter(
      element => set2.has(element)
    );
  
    return intersection;
  }

  const handleRadioChange = (event, primaryText) => {
    const value = event.target.value;
    const defaultLocation = ['rental', 'airport', 'outStation']
    const array = selectedValues
    const intersectionValue = getIntersection(defaultLocation, array)
    if(intersectionValue?.length > 0){
      const index = array.indexOf(intersectionValue[0]);
      if (index > -1) { // only splice array when item is found
        array.splice(index, 1); // 2nd parameter means remove one item only
      }
    }
    const updatedValue = [...array, value]
    setSelectedValues(updatedValue)
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickDropdown = (itemId) => {
    const updatedOpenState = dropdownOpen.map((isOpen, index) =>
      itemId === filterdata[index].id ? !isOpen : isOpen
    );
    setDropdownOpen(updatedOpenState);
  };

  const handleApply = () => {
    onFilterChange(selectedValues);
    handleClose();
  };

  const handleReset = () => {
    onRestFilter();
    handleClose();
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : null}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : null}
        className="vendorFilterIcon commonFilter"
        onClick={handleClick}
      >
        <Grid container alignItems={'center'} role="presentation">
          <Box
            className="filterIconSvg justifyCenter ml10"
            onClick={handleClick}
            role="presentation"
          >
            <img
              src={selectedValues?.length > 0 ? activeFilter : filterIcon}
              alt="FilterIcon"
            />
          </Box>
        </Grid>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="filterMenu"
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <FormGroup className="filterCheckbox">
          {filterdata?.map((item, index) => (
            <div key={item.id}>
              <ListItemButton
                onClick={() => handleClickDropdown(item.id)}
                className="p0"
              >
                <ListItemText
                  primary={item.primaryText}
                  className="filterDropdown"
                />
                <ListItemIcon className="filterDropdownIcon">
                  {dropdownOpen[index] ? (
                    <ExpandLess className="fontMedium colorBlue" />
                  ) : (
                    <ExpandMore className="fontMedium colorBlue" />
                  )}
                </ListItemIcon>
              </ListItemButton>
              <Collapse in={dropdownOpen[index]} timeout="auto" unmountOnExit>
                <FormGroup className="filterBox">
                  {item?.subItems?.map((subItem) => (
                    <FormControlLabel
                      key={subItem.value}
                      control={
                        item.isRadio ? (
                          <Radio
                            onChange={(e) => handleRadioChange(e, item.primaryText)}
                            value={subItem.value}
                            checked={selectedValues.includes(subItem.value)}
                          />
                        ) : (
                        <Checkbox
                          key={props?.defaultStatus?.includes(subItem.value)}
                          onChange={(e) =>
                            handleCheckboxChange(e, item.primaryText)
                          }
                          value={subItem.value}
                          defaultChecked={
                            props.defaultStatus?.includes(subItem.value) ||
                            props?.defaultLocation?.includes(subItem.value)
                          }
                        />
                        )
                      }
                      label={
                        <Typography variant='body2' fontWeight={500}>
                          {item?.star && (
                            <img
                              src={star}
                              className="feedbackStar mr6"
                              alt="star"
                            />
                          )}
                          {subItem?.list ? subItem?.list : subItem?.value}
                        </Typography>
                      }
                    />
                  ))}
                </FormGroup>
              </Collapse>
              {index !== filterdata?.length - 1 && <Divider />}
            </div>
          ))}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 1,
              mt: 1,
              ml: 0
            }}
          >
            <CommonButton
              name="Reset"
              btnClass={'btnSm btnTransparent filterReset'}
              onClick={handleReset}
            />
            <CommonButton
              name="Apply"
              btnClass={'btnSm btnYellow'}
              onClick={handleApply}
            />
          </Box>
        </FormGroup>
      </Menu>
    </div>
  );
}

export default CommonFilter;
